import HelperFunctions from "@/classes/HelperFunctions";
import DateFunctions from "@/classes/DateFunctions";
import ApiServiceFunctions from "@/classes/ApiServiceFunctions";

const methods = Object.assign({}, HelperFunctions, DateFunctions, ApiServiceFunctions);

export default methods;